import { PerspectiveCamera } from "three";
import { SceneCameraBehaviour } from "../../behaviors/internal";
import { Camera } from "./internal";
/**
 * Scene camera. Derived class
 *
 * @class SceneCamera
 * @param {SceneGraphNode} parentNode
 * @extends {Camera}
 * @constructor
 */
export class SceneCamera extends Camera {
    /**
     * @method constructor
     * @param {SceneGraphNode} parentNode
     * @parram {TraversalState} traversalState
     */
    constructor(parentNode) {
        super(parentNode);
        this.iCamera = new PerspectiveCamera();
        this._sceneCameraBehavior = new SceneCameraBehaviour(this, [0, 0, 0], [0, 0, 0]);
        this.addBehavior(this._sceneCameraBehavior);
    }
    /**
     * writes : traversalstate.scenecamera
     *
     * @method init
     * @param {TraversalState} traversalState
     */
    init(traversalState) {
        super.init(traversalState);
    }
    getWidth() {
        return this.iCamera.fullWidth;
    }
    getHeight() {
        return this.iCamera.fullHeight;
    }
    setPosition(position) {
        this._sceneCameraBehavior.setPosition(position);
    }
    getZoomLevel() {
        return this._sceneCameraBehavior.zoom;
    }
    getPosition() {
        return this._sceneCameraBehavior.position.clone();
    }
    getPositionAbsolute() {
        return this._sceneCameraBehavior.positionAbsolute.clone();
    }
    setOrientation(orientation) {
        this._sceneCameraBehavior.setOrientation(orientation);
    }
    getOrientation() {
        return this._sceneCameraBehavior.getOrientation();
    }
    getLatLon() {
        return this._sceneCameraBehavior.getLatLon();
    }
    setCameraIntrinsics(cameraIntrinsics) {
        this._sceneCameraBehavior.setCameraIntrinsics(cameraIntrinsics);
    }
}
//# sourceMappingURL=scenecamera.js.map